import {
  GoogleMap,
  GoogleMapProps,
  useJsApiLoader,
} from '@react-google-maps/api';
import { ProgressSpinner } from 'primereact/progressspinner';
import { FC, PropsWithChildren } from 'react';

const center = {
  lat: -9.070109,
  lng: -53.45633,
};

const mapStyles: google.maps.MapOptions = {
  styles: [{ elementType: 'labels', stylers: [{ visibility: 'off' }] }],
  fullscreenControl: false,
  mapTypeControl: false,
  streetViewControl: false,
};

const Map: FC<PropsWithChildren<GoogleMapProps>> = ({ children, ...props }) => {
  const { isLoaded, loadError } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: 'AIzaSyAKtTIN2iGG4uPUMDGP0gHlUz5FBuWAagI',
    language: 'pt-BR',
  });

  if (!isLoaded || loadError) {
    return (
      <div
        style={props.mapContainerStyle}
        className={`${props.mapContainerClassName} align-content-center text-center`}
      >
        <ProgressSpinner />
      </div>
    );
  }

  return (
    <GoogleMap
      id="google-map"
      zoom={4}
      center={center}
      {...props}
      options={{ ...mapStyles, ...props.options, mapTypeId: props.mapTypeId }}
    >
      {children}
    </GoogleMap>
  );
};

export default Map;
